var map = {
	"./aq/languages/en/site.json": [
		"6552",
		"chunk-2d0cfa92"
	],
	"./as/languages/en/site.json": [
		"52a2",
		"chunk-2d0c8044"
	],
	"./ba/languages/en/site.json": [
		"57ca",
		"chunk-2d0c9376"
	],
	"./ia/languages/en/site.json": [
		"f832",
		"chunk-2d22d767"
	],
	"./oc/languages/en/site.json": [
		"5104",
		"chunk-2d0c7696"
	],
	"./st/languages/en/site.json": [
		"60a2",
		"chunk-2d0ced21"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d794";
module.exports = webpackAsyncContext;